import { gql } from '@apollo/client';

type NextGenAdminMembership = {
  organization: string;
  roles: string[];
};

export type GetAdminByIdResponse = {
  adminUserById: {
    email: string;
    firstName: string;
    lastName: string;
    roles: string[];
    tenant?: string;
    memberships?: NextGenAdminMembership[];
  };
};

export const GET_ADMIN_BY_ID = gql`
  query adminUserById($id: ID!) {
    adminUserById(id: $id) {
      email
      firstName
      lastName
      roles
      tenant
      memberships {
        organization
        roles
      }
    }
  }
`;
